/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellModelExport } from "./CellModelExport";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var RowSeparatorModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowSeparatorModelExport, _super);
    function RowSeparatorModelExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowSeparatorModelExport.prototype.get_ac = function () {
        return "RowSeparator";
    };
    RowSeparatorModelExport.prototype.ad = function (a) {
        _super.prototype.ad.call(this, a);
    };
    RowSeparatorModelExport.$t = markType(RowSeparatorModelExport, 'RowSeparatorModelExport', CellModelExport.$);
    return RowSeparatorModelExport;
}(CellModelExport));
export { RowSeparatorModelExport };
//# sourceMappingURL=RowSeparatorModelExport.js.map
